module.exports = __webpack_public_path__ + "static/media/Afzuigkap.509d8c84.mp3";